import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HomePageContentRepository from "src/repository/HomePageContentRepository";
import { __remove, __set } from "src/store/axios_indicator";
import HomePageDocumentContentRepository from "../../../repository/HomePageDocumentContentRepository";
import allTabsCountResponseMaker from "../../../service/HomePageContentAPICall/allTabsCountResponseMaker";

export const getContentTabCount = createAsyncThunk('home_getContentTabCount', async (params) => {
    return await new HomePageContentRepository().getContentTabCount(params.searchParam);
});
export const getAllTabsCount = createAsyncThunk('home_getAllTabsCount', async (params) => {
    __set('ALL_COUNT_API_CALL');
    return await new HomePageContentRepository().getAllTabsCount(params);
});

export const getDocumentList = createAsyncThunk('home_getDocumentList', async (params) => {
    let res = await new HomePageDocumentContentRepository().getDocumentList(params.search, params.page, params.limit, params.orderByDirection, params.orderBy, params.selectedFilterList, params.dateRangeObject)
    let result = {}
    result.data = res.data;
    return result
});

export const getDocumentListAutosuggest = createAsyncThunk('home_getDocumentListAutosuggest', async (params) => {
    let res = await new HomePageDocumentContentRepository().getDocumentList(params.search, params.page, params.limit, params.orderByDirection, params.orderBy, params.selectedFilterList, params.dateRangeObject)
    let result = {}
    result.data = res.data;
    return result
});

const initialState = {
    contentTabCount: {},
    allTabsCount: allTabsCountResponseMaker.defaultData(),
    documentContent: {
        list: {},
        facets: {},
        count: 0,
    },
    documentContentAutosuggest: {
        list: {},
        facets: {},
        count: 0,
    },
};
const slice = createSlice({
    name: "HomePageContent",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [getContentTabCount.fulfilled]: (state, { payload }) => {
            state.contentTabCount = payload;
            return state;
        },
        [getAllTabsCount.fulfilled]: (state, { payload }) => {
            state.allTabsCount = payload.data.allTabsCount;
            state.contentTabCount = payload.data?.allTabsCount?.contentTabCount;
            __remove('ALL_COUNT_API_CALL');
            return state;
        },
        [getDocumentList.fulfilled]: (state, { payload }) => {
            state.documentContent.list = payload.data.documentList;
            state.documentContent.facets = payload.data.facets;
            state.documentContent.count = payload.data.count;
            //__remove('ALERT_API_CALL');
        },
        [getDocumentListAutosuggest.fulfilled]: (state, { payload }) => {
            state.documentContentAutosuggest.list = payload.data.documentList;
            state.documentContentAutosuggest.facets = payload.data.facets;
            state.documentContentAutosuggest.count = payload.data.count;
            //__remove('ALERT_API_CALL');
        },
    },
});

export let { } = slice.actions;

export default slice.reducer;